import { Suspense } from 'react';
import { useIsOnboardingCompleted } from '#shared/api/onboarding';
import { OnboardingStepper } from './OnboardingStepper';
import { OnboardingStepperStub } from './OnboardingStepperStub';

export function OnboardingStepperSuspense() {
    const isCompleted = useIsOnboardingCompleted();

    if (isCompleted) {
        return null;
    }

    return (
        <Suspense fallback={<OnboardingStepperStub />}>
            <OnboardingStepper />
        </Suspense>
    );
}
